import { render } from "./DrillLibrary.vue?vue&type=template&id=5fb6e2ab&scoped=true"
import script from "./DrillLibrary.vue?vue&type=script&lang=js"
export * from "./DrillLibrary.vue?vue&type=script&lang=js"

import "./DrillLibrary.vue?vue&type=style&index=0&id=5fb6e2ab&scoped=true&lang=css"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5fb6e2ab"]])

export default __exports__